export const CONFIRMATION_TYPES = {
  ACCOUNT: 'accountConfirmation',
  EMAIL: 'emailChange',
  PASSWORD: 'passwordChange'
}
